import React, { useState } from 'react';
import 'typeface-roboto';
import 'typeface-open-sans';
import './App.scss';
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import Footer from './components/Footer';
import Homepage from './components/Homepage';
import Login from './components/Login';
import { StoreProvider } from "./components/StoreContext";
import { Router } from 'react-router-dom';
import history from './history';
import Storage from './components/utils/Storage';
import { Helmet } from "react-helmet";
import Raggera from './Raggera';
import LangBar from './LangBar';
import LangRequest from './components/LangRequest';




function App() {
    const wSide = 14; //fissa, larghezza sidebar
    const [sidebarshow, setSidebarshow] = useState(true);


    // useEffect(() => { document.title = 'Matrec' });
    const toggleSidebarshow = () => setSidebarshow(!sidebarshow);
    const current_user = Storage.getItem('current_user');
    if (!current_user) {
        return (
            <>
                <div
                    className="position-absolute"
                    style={{ top: 0, right: 0, zIndex: 299 }}
                >
                    <LangBar />
                </div>
                <LangRequest pacchetto="Login">
                    <Login />
                </LangRequest>

            </>

        );
    }

    return (
        <StoreProvider>
            <div
                className="position-fixed"
                style={{ top: 0, right: 0, zIndex: 1030 }}
            >
                <div className="d-flex align-items-center pr-3" style={{ height: '4rem' }}>
                    <LangBar saveUserLang hiddenable />
                </div>
            </div>
            <Router history={history}>
                <LangRequest pacchetto="Site">
                    <div className="areaPrincipale">
                        <Header onToggleSidebar={toggleSidebarshow} wSide={wSide} sidebarshow={sidebarshow} />
                        <Sidebar onToggleSidebar={toggleSidebarshow} show={sidebarshow} wSide={wSide} >
                            <div style={{ paddingTop: '4rem', minHeight: '90vh' }}>
                                <Raggera />
                                <div
                                    className="position-relative"
                                    style={{
                                        zIndex: 200,
                                    }}>
                                    <Homepage />
                                </div>
                            </div>
                        </Sidebar>
                        <Footer />
                    </div>
                </LangRequest>
            </Router>
        </StoreProvider>
    );
}
function Application() {
    return (
        <>
            <Helmet htmlAttributes={{ 'lang': 'it_IT' }} />
            <App />
        </>
    );
};

export default Application;
